/* jshint esversion: 6 */
import Vue from 'vue'
import Vuex from 'vuex'
import jConsole from '../util/jconsole'
import utils from '../util/utils'
// import develop from '../util/config'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    origins: window.location.protocol.includes('file') ? `https://www.chiens.cn/blog` : `${window.location.protocol}//${window.location.hostname}/blog`, // https://www.chiens.cn/blog ${window.location.protocol}//${window.location.hostname}/blog
    userInfo: null,
    vm: null,
    hotContentList: [],
    nowContentList: [],
    isLogin: false
  },
  mutations: {
    setUserInfo (state) {
      let userInfo = localStorage.getItem('userData')
      if (userInfo) {
        state.userInfo = userInfo
        state.isLogin = true
      } else {
        state.isLogin = false
      }
    },
    _vm (state, payload) {
      state.vm = payload
    },
    getHotContent (state) {
      state.vm.$axios.get('/getHotContent').then(res => {
        jConsole.success(res.data.data)
        state.hotContentList = []
        res.data.data.forEach(item => {
          item.avatarUrl = item.avatarUrl ? `${state.origins}/userAvatar/${item.avatarUrl}` : ''
          item.timer = item.time
          item.time = utils.formatTime(item.time)
          state.hotContentList.push(item)
        })
      }).catch(err => {
        jConsole.error(err.message)
      })
    },
    getUserInfos (state) {
      let userInfo = JSON.parse(localStorage.getItem('userData'))
      console.log(userInfo)
      if (userInfo) {
        state.vm.$axios.post('/getUserInfo', state.vm.$qs.stringify({uid: userInfo.uid})).then(res => {
          jConsole.success(res.data.data)
          let info = {
            'username': res.data.data[0].username,
            'uid': res.data.data[0].uid,
            'avatar': res.data.data[0].avatarUrl ? `${state.origins}/userAvatar/${res.data.data[0].avatarUrl}` : ''
          }
          localStorage.setItem('userData', JSON.stringify(info))
        }).catch(err => {
          jConsole.error(err.message)
        })
      }
    },
    getNowContent (state) {
      state.vm.$axios.get('/getNowContent').then(res => {
        jConsole.success(res.data.data)
        state.nowContentList = []
        res.data.data.forEach(item => {
          item.avatarUrl = item.avatarUrl ? `${state.origins}/userAvatar/${item.avatarUrl}` : ''
          item.timer = item.time
          item.time = utils.formatTime(item.time)
          state.nowContentList.push(item)
        })
      }).catch(err => {
        jConsole.error(err.message)
      })
    },
    setLoginState (state, payload) {
      state.isLogin = payload.status
    }
  },
  getters: {
    getUserInfo: state => state.userInfo ? JSON.parse(state.userInfo) : null,
    getHotContentList: state => JSON.parse(JSON.stringify(state.hotContentList)),
    getLoginState: state => state.isLogin
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js